import { createContext } from 'react'
export const LastNewsContext = createContext([])
